import { render, staticRenderFns } from "./VerificationAccountPage.vue?vue&type=template&id=a1675ac0&scoped=true"
import script from "./VerificationAccountPage.vue?vue&type=script&lang=js"
export * from "./VerificationAccountPage.vue?vue&type=script&lang=js"
import style0 from "./VerificationAccountPage.vue?vue&type=style&index=0&id=a1675ac0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1675ac0",
  null
  
)

export default component.exports